import { flexRender, Table } from '@tanstack/react-table';
import { SourcingFunnelDetails } from 'api-clients/monolith';
import clsx from 'clsx';

interface SourcingOpeningsProps {
  table: Table<SourcingFunnelDetails>;
  gridTemplateColumns: string;
}

export function SourcingOpenings({
  table,
  gridTemplateColumns,
}: SourcingOpeningsProps) {
  return (
    <>
      {table.getRowModel().rows.map(row => (
        <div
          className="grid items-start"
          style={{ gridTemplateColumns }}
          key={row.id}
        >
          {row.getVisibleCells().map(cell => (
            <div
              key={cell.id}
              className={clsx(
                'flex flex-col items-start gap-2 overflow-hidden px-5 py-6',
                cell.column.id === 'name' && 'max-w-[240px]',
              )}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </div>
          ))}
        </div>
      ))}
    </>
  );
}
